import { Routes, Route, Navigate } from "react-router-dom";

import { Layout } from "@/components/Layout";
import { pageAtRouteMap } from "@/pages";
import PageNotFoundPage from "@/pages/PageNotFoundPage";
import { routeNames, routes } from "@/routes";

/**
 * Create an array of objects with path and the component properties
 */
const pages = routeNames.map((routeName) => {
    const Component = pageAtRouteMap[routeName];
    return { path: routes[routeName].path, Component };
});

export const AppRoutes = () => (
    <Routes>
        <Route element={<Layout />}>
            <Route index element={<Navigate to={routes.officeMap.path} replace />} />
            {pages.map(({ path, Component }) => (
                <Route key={path} path={path} element={<Component />} />
            ))}
            <Route key="404" path="*" element={<PageNotFoundPage />} />
        </Route>
    </Routes>
);
